import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider, injectGlobal } from 'styled-components';
import { Theme } from 'oxyrion-ui/lib';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import ErrorFalbackComponent from './Components/ErrorFalbackComponent';
import registerServiceWorker from './registerServiceWorker';
import authorize from './Auth';
import { Provider } from './Store/index';
import App from './App';

const { NODE_ENV, SENTRY_DSN } = process.env;

Sentry.init({
  dsn: SENTRY_DSN,
  tracesSampleRate: 1.0,
  environment: NODE_ENV,
  denyUrls: [/localhost:3001/i],
  integrations: [new Integrations.BrowserTracing()],
});

const Application = authorize(App);
// const Application = App;

injectGlobal` 
@import url('https://fonts.googleapis.com/css?family=Open+Sans:300,400,700,700i');

::-webkit-scrollbar {
  width: 10px;
  height: 2px;
}
::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}
::-webkit-scrollbar-thumb {
  background: #636363;
  border: 0px solid #ffffff;
  border-radius: 50px;
}
::-webkit-scrollbar-thumb:hover {
  background: #70af00;
}
::-webkit-scrollbar-thumb:active {
  background: #70af00;
}
::-webkit-scrollbar-track {
  background: #dedede;
  border: 0px solid #9e0000;
  border-radius: 0px;
}
::-webkit-scrollbar-track:hover {
  background: #ffffff;
}
::-webkit-scrollbar-track:active {
  background: #ffffff;
}
::-webkit-scrollbar-corner {
  background: transparent;
}


  body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: sans-serif   
  }
`;

ReactDOM.render(
  <React.StrictMode>
    {/* <ErrorBoundery> */}
    <Sentry.ErrorBoundary fallback={ErrorFalbackComponent} showDialog>
      <ThemeProvider theme={Theme}>
        <Provider>
          <Application />
        </Provider>
      </ThemeProvider>
    </Sentry.ErrorBoundary>
    {/* </ErrorBoundery> */}
  </React.StrictMode>,
  document.getElementById('root'),
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js